import React from 'react';
import { Stack } from '@moda/om';
import { Order, OrderItem } from '../../../hooks/useOrder';
import { OrderItemDetails } from '../OrderItemDetails';
import { OrderItemPrice } from '../OrderItemPrice';
import { OrderItemImage } from '../OrderItemImage';
import { AccountOrderItemDetailsMobile } from '../AccountOrderItemDetailsMobile';
import { AccountOrderItemDetailsDesktop } from '../AccountOrderItemDetailsDesktop';

import './AccountOrderItem.scss';

interface Props {
  item?: OrderItem;
  showDetails?: boolean;
  showExtraDetails?: boolean;
  showShippingStatus?: boolean;
  showTrackAndReturn?: boolean;
  showPayRemainingBalance?: boolean;
  order?: Order;
}

export const AccountOrderItem: React.FC<Props> = ({
  item,
  order,
  showDetails = true,
  showExtraDetails = false,
  showTrackAndReturn = false,
  showShippingStatus = true
}) => {
  if (!item) return null;

  return (
    <Stack className="AccountOrderItem" direction="horizontal" space={6}>
      <div className="AccountOrderItem__image">
        <OrderItemImage item={item} imageSize="small" />
      </div>
      <Stack space={3} className="AccountOrderItem__details">
        {showDetails && (
          <>
            <OrderItemDetails item={item} showExtraDetails={showExtraDetails} />
            <OrderItemPrice item={item} layout="row" />
          </>
        )}

        <AccountOrderItemDetailsMobile
          item={item}
          order={order}
          showShippingStatus={showShippingStatus}
          showTrackAndReturn={showTrackAndReturn}
        />
      </Stack>
      <AccountOrderItemDetailsDesktop
        item={item}
        order={order}
        showShippingStatus={showShippingStatus}
        showTrackAndReturn={showTrackAndReturn}
      />
    </Stack>
  );
};
